import React from "react";

/**
 * Subtle animated background:
 * - Faint drifting grid
 * - Two slow-pulsing accent glows
 * - A handful of slowly rising particles
 * - Soft vignette to deepen edges
 *
 * All animations respect prefers-reduced-motion (see index.css).
 */
const PARTICLES = [
    { left: "8%", delay: "0s", duration: "28s" },
    { left: "17%", delay: "-9s", duration: "34s" },
    { left: "29%", delay: "-18s", duration: "30s" },
    { left: "41%", delay: "-4s", duration: "38s" },
    { left: "53%", delay: "-22s", duration: "26s" },
    { left: "62%", delay: "-12s", duration: "33s" },
    { left: "74%", delay: "-2s", duration: "40s" },
    { left: "85%", delay: "-26s", duration: "29s" },
    { left: "93%", delay: "-14s", duration: "36s" },
];

export const Background = () => {
    return (
        <div className="plenum-bg-layer" aria-hidden="true">
            <div className="plenum-glow" />
            <div className="plenum-glow plenum-glow-2" />
            <div className="plenum-grid" />
            {PARTICLES.map((p, i) => (
                <span
                    key={i}
                    className="plenum-particle"
                    style={{
                        left: p.left,
                        animationDelay: p.delay,
                        animationDuration: p.duration,
                    }}
                />
            ))}
            <div className="plenum-vignette" />
        </div>
    );
};

export default Background;
